import { parseAsString, useQueryState } from 'nuqs'

import { ESIGNATURE_TAB_KEY } from '@/components/misc/ReferralESignatureConsentPdfPreview/constants'
import { SEARCH_PARAMS } from '@/lib/searchParams'

export function useESignaturePreviewTab() {
  return useQueryState(
    SEARCH_PARAMS.referralESignatureConsentPdfPreview.eSignatureTab,
    parseAsString.withDefault(ESIGNATURE_TAB_KEY),
  )
}
